import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'

import ThemeProvider from '@/context/ThemeProvider'
import PreviewWrapper from '../../components/PreviewWrapper'

import useOnboardingContext from '@/hooks/useOnboardingContext'
import TypographyWrapper from '../TypographyWrapper'
import FullStepHeader from '../FullStepHeader'
import useIsMobile from '../../../../hooks/useIsMobile'

const WizardStepPublished = () => {
  const { selectedTemplate, setActualStep, siteplusLoginUrl, productInstanceId, setActualSubStep, clearOnboardingSessionId, refetchStoreOnboarding, layout } = useOnboardingContext()
  const TemplateComponent = selectedTemplate?.template || selectedTemplate?.templates[layout]?.template
  const numberOfTemplates = parseInt(window.sessionStorage.getItem(`templates_created_${productInstanceId}`))

  const { isMobile } = useIsMobile()

  return (
    <Box className='flex min-h-screen' sx={{ background: '#F3F4F8' }}>
      <Box
        sx={{ background: '#F3F4F8' }}
        className='flex flex-col w-full h-full gap-5 md:gap-0'
      >
        <FullStepHeader />
        <Card
          component={'section'}
          square={isMobile}
          elevation={isMobile? 0: 1}
          className='max-w-[100%] md:max-w-[780px] md:my-20 md:mx-auto h-full'
          sx={{
            ...(isMobile? { borderRadius: 0, border: "none", boxShadow: "none", background: "#f3f4f8" }: { boxShadow: '0px 0px 12px 2px #D8D9DA'})
          }}
        >
          <Box
            style={{
              position: 'relative',
              borderBottom: '1px solid rgba(0,0,0,.1)',
              ...(!isMobile? {}: {
                boxShadow: 'rgb(217, 217, 217) 0px 24px 0px 0px',
                borderRadius: "0 0 8px 8px"
              })
            }}
            className="w-full md:w-[780px]"
          >
            <ThemeProvider>
              <TypographyWrapper>
                <PreviewWrapper updateHeight>
                  <TemplateComponent />
                </PreviewWrapper>
              </TypographyWrapper>
            </ThemeProvider>
          </Box>
          <Box
            component={'aside'}
            className='flex flex-col items-center gap-5 py-14 px-6 md:py-10 md:px-5 max-w-[530px] mx-auto'
          >
            <Typography
              variant='h3'
              textAlign={'center'}
            >
              🎉 Huzzah! 🎉
            </Typography>
            <span
              className='w-3/4 text-lg md:w-fit font-semibold text-center md:text-xl'
            >
              Your one of a kind website template has been created. It looks good on you.
            </span>
            <Typography
              variant='subtitle2'
              color='textSecondary'
              textAlign={'center'}
              className='hidden md:block'
            >
              Now you can fine tune all the details in our editor. Or if for some reason you’re not feeling this one,  {(numberOfTemplates < 5) ? <> feel free to{' '}
                <Typography
                  component={'span'}
                  className='underline underline-offset-4 cursor-pointer !font-semibold'
                  onClick={() => {
                    clearOnboardingSessionId()
                    refetchStoreOnboarding()
                    setActualStep(0)
                    setActualSubStep(0)
                    window.location.assign('/')
                  }}
                >
                  start over again
                </Typography>{' '}
                from scratch.
              </> : <></>}
            </Typography>
            <Button
              variant='contained'
              fullWidth={isMobile}
              className='md:w-fit !px-5 !mt-5'
              onClick={() => { window.location.assign(siteplusLoginUrl) }}
            >
              Open in Editor
            </Button>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default WizardStepPublished;